import { render, staticRenderFns } from "./TermsPersonalThirdPartyLGT.vue?vue&type=template&id=36c9e5c4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports